<!-- breadcrumb start -->
<app-breadcrumb [title]="'Order Confirmation'" [breadcrumb]="'Order Confirmation'"></app-breadcrumb>
<!-- breadcrumb End -->

<!-- Loading section -->
<section class="section-b-space" *ngIf="isLoading">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h3 class="mt-4">Loading your order details...</h3>
          <p>Please wait while we fetch your order information.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Thank you section if orderDetails is available -->
<section class="section-b-space light-layout" *ngIf="!isLoading && orderDetails">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="success-text">
          <i class="fa fa-check-circle" aria-hidden="true"></i>
          <h2>Thank you</h2>
          <p>Payment has been received. Order Placed Successfully.</p>
          <p>Order ID: {{ orderDetails.order_id }}</p>
          <button class="btn btn-danger" (click)="download()">Download Request Form</button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Order details section -->
<section class="section-b-space" *ngIf="!isLoading && orderDetails">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="product-order">
          <h3>Your order details</h3>
          <div class="row product-order-detail" *ngFor="let product of orderDetails.product_details">
            <div class="col-4 order_detail">
              <div>
                <h4>Product Name</h4>
                <h5>{{ product.name }}</h5>
              </div>
            </div>
            <div class="col-4 order_detail">
              <div>
                <h4>Quantity</h4>
                <h5>{{ orderDetails.qty }}</h5>
              </div>
            </div>
            <div class="col-4 order_detail">
              <div>
                <h4>Price</h4>
                <h5>{{ (orderDetails.price - orderDetails.discount) | currency:'USD' }}</h5>
              </div>
            </div>
          </div>
          <div class="total-sec">
            <ul>
              <li>Subtotal <span>{{ (orderDetails.price - orderDetails.discount) | currency:'USD' }}</span></li>
              <li>Shipping <span>$0.00</span></li>
              <li>Tax <span>$0.00</span></li>
            </ul>
          </div>
          <div class="final-total">
            <h3>Total <span>{{ (orderDetails.price - orderDetails.discount) | currency:'USD' }}</span></h3>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="row order-success-sec">
          <div class="col-sm-6">
            <h4>Summary</h4>
            <ul class="order-detail">
              <li>Order ID: {{ orderDetails.order_id }}</li>
              <li>Order Date: {{ orderDetails.created_at | date }}</li>
              <li>Order Total: {{ (orderDetails.price - orderDetails.discount) | currency:'USD' }}</li>
            </ul>
          </div>
          <div class="col-sm-6">
            <h4>Shipping Address</h4>
            <ul class="order-detail">
              <li>{{ orderDetails.shippingDetails?.address }}</li>
              <li>{{ orderDetails.shippingDetails?.state }}</li>
              <li>{{ orderDetails.shippingDetails?.country }}, {{ orderDetails.shippingDetails?.postalcode }}</li>
              <li>Contact No: {{ orderDetails.shippingDetails?.phone }}</li>
            </ul>
          </div>
          <div class="col-sm-12 payment-mode">
            <h4>Payment Method</h4>
            <p>Pay on Delivery (Cash/Card). Cash on delivery (COD) available. Card/Net banking acceptance subject to device availability.</p>
          </div>
          <div class="col-md-12">
            <div class="delivery-sec">
              <h3>Order Date </h3>
              <h2>{{orderDetails.updated_at | date: "medium" }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Error section -->
<section class="section-b-space" *ngIf="!isLoading && !orderDetails">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="text-center">
          <i class="fa fa-exclamation-circle text-danger" style="font-size: 48px;"></i>
          <h3 class="mt-4">Unable to load order details</h3>
          <p>We couldn't find the order details. Please contact support if this persists.</p>
          <a [routerLink]="'/'" class="btn btn-solid">Back to Home</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Section ends -->
